import { message } from 'antd'
import api from 'api'
import constants from 'helpers/constants'
import { urls } from 'helpers/urls'
import Cookies from 'js-cookie'
import Link from 'next/link'
import { TFunction, useTranslation } from 'next-i18next'

const logout = async (t: TFunction) => {
  const { error }: { error: any } = await api.delete('/sign_out')
  if (error) {
    console.log(error)
  } else {
    Cookies.remove(constants.cookieName)
    message.success(t('ログアウトしました') as string)
    if (window.location.pathname.includes(urls.account()))
      window.location.replace('/')
    else window.location.reload()
  }
}

export const getAccountMenuItems = (t: TFunction, needConfirm = false) => {
  const { i18n } = useTranslation()
  return [
    {
      key: 'profile',
      label: (
        <Link href="/account/owner/profile">
          <a>{t('プロフィール編集') as string}</a>
        </Link>
      ),
    },
    {
      key: 'kyc',
      label: (
        <Link href={urls.account('owner/kyc')}>
          <a>{t('本人確認') as string}</a>
        </Link>
      ),
    },
    {
      key: 'edit',
      label: (
        <Link href={urls.account('edit')}>
          <a>{t('アカウント管理') as string}</a>
        </Link>
      ),
    },
    {
      key: 'orders',
      label: (
        <Link href={urls.account('orders')}>
          <a>{t('注文履歴') as string}</a>
        </Link>
      ),
    },
    {
      key: 'transactions',
      label: (
        <Link href={urls.account('transactions')}>
          <a style={{ position: 'relative' }}>
            {t('取引一覧') as string}
            {needConfirm && (
              <div
                style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: '#FF4D4F',
                  position: 'absolute',
                  top: 0,
                  right: -10,
                }}
              />
            )}
          </a>
        </Link>
      ),
    },
    {
      key: 'lotteries',
      label: (
        <Link href={urls.account('lotteries')}>
          <a>{t('エントリー履歴') as string}</a>
        </Link>
      ),
    },
    {
      key: 'follows',
      label: (
        <Link href={urls.account('follows')}>
          <a>{t('お気に入り') as string}</a>
        </Link>
      ),
    },
    {
      key: 'event_checkins',
      label: (
        <Link href={urls.account('event_checkins')}>
          <a>{t('イベント訪問履歴') as string}</a>
        </Link>
      ),
    },
    {
      key: 'shipping_addresses',
      label: (
        <Link href={urls.account('shipping_addresses')}>
          <a>{t('お届け先') as string}</a>
        </Link>
      ),
    },
    {
      key: 'payments',
      label: (
        <Link href={urls.account('payments')}>
          <a>{t('お支払い方法') as string}</a>
        </Link>
      ),
    },
    {
      key: 'support',
      label: (
        <Link
          href={
            i18n.language === 'en'
              ? 'https://help.cloud.artx.com/hc/en-us/requests/new?ticket_form_id=45768582289177'
              : 'https://help.cloud.artx.com/hc/ja/requests/new?ticket_form_id=45616687352473'
          }
        >
          <a>{t('サポートに問い合わせる') as string}</a>
        </Link>
      ),
    },
    {
      key: 'logout',
      label: (
        <a onClick={() => logout(t)}>
          <span>{t('ログアウト') as string}</span>
        </a>
      ),
    },
  ]
}
